import React, { useState, useMemo, useEffect, useLayoutEffect } from "react";
import ColumnReportModal from "./ColumnReportModal";
import { KANBAN_COMPACT_MQ } from "./compactLayout";
import useStableCallback from "../../hooks/useStableCallback";
import { makeStyles } from "@material-ui/core/styles";
import {
  Paper,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  Badge,
  Tooltip,
  Button,
} from "@material-ui/core";
import {
  MoreVert as MoreVertIcon,
  Add as AddIcon,
  People as PeopleIcon,
  Person as PersonIcon,
  ViewColumn as ViewColumnIcon,
  Assignment as AssignmentIcon,
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  Schedule as ScheduleIcon,
  Flag as FlagIcon,
  Star as StarIcon,
  Work as WorkIcon,
  Phone as PhoneIcon,
  Email as EmailIcon,
  Chat as ChatIcon,
  ContactMail as ContactMailIcon,
  Business as BusinessIcon,
  Done as DoneIcon,
  HourglassEmpty as HourglassEmptyIcon,
  Pause as PauseIcon,
  Error as ErrorIcon,
  TrendingUp as TrendingUpIcon,
  AttachMoney as AttachMoneyIcon,
  // Novos ícones adicionados
  LocalShipping as LocalShippingIcon,
  Inbox as InboxIcon,
  Timer as TimerIcon,
  Build as BuildIcon,
  PlayArrow as PlayArrowIcon,
  ThumbUp as ThumbUpIcon,
  ThumbDown as ThumbDownIcon,
  Warning as WarningIcon,
  Help as HelpIcon,
  Info as InfoIcon,
  Block as BlockIcon,
  Archive as ArchiveIcon,
  Send as SendIcon,
  Receipt as ReceiptIcon,
  Payment as PaymentIcon,
  ShoppingCart as ShoppingCartIcon,
  Loyalty as LoyaltyIcon,
  CardGiftcard as CardGiftcardIcon,
  LocalOffer as LocalOfferIcon,
  Label as LabelIcon,
  Bookmark as BookmarkIcon,
  Notifications as NotificationsIcon,
  AccountCircle as AccountCircleIcon,
  Group as GroupIcon,
  SupervisorAccount as SupervisorAccountIcon,
  VerifiedUser as VerifiedUserIcon,
  Security as SecurityIcon,
  Settings as SettingsIcon,
  Dashboard as DashboardIcon,
  Assessment as AssessmentIcon,
  Timeline as TimelineIcon,
  CalendarToday as CalendarTodayIcon,
  Event as EventIcon,
  Room as RoomIcon,
  Language as LanguageIcon,
  Public as PublicIcon,
  VpnKey as VpnKeyIcon,
  Lock as LockIcon,
  LockOpen as LockOpenIcon,
  Visibility as VisibilityIcon,
  VisibilityOff as VisibilityOffIcon,
  CloudUpload as CloudUploadIcon,
  CloudDownload as CloudDownloadIcon,
  Folder as FolderIcon,
  FolderOpen as FolderOpenIcon,
  Description as DescriptionIcon,
  NoteAdd as NoteAddIcon,
  Notes as NotesIcon,
  Print as PrintIcon,
  Refresh as RefreshIcon,
  Sync as SyncIcon,
  Update as UpdateIcon,
  NewReleases as NewReleasesIcon,
  Announcement as AnnouncementIcon,
  Campaign as CampaignIcon,
  EmojiEvents as EmojiEventsIcon,
  Grade as GradeIcon,
  Favorite as FavoriteIcon,
  FavoriteBorder as FavoriteBorderIcon,
  QuestionAnswer as QuestionAnswerIcon,
  Forum as ForumIcon,
  Comment as CommentIcon,
  RateReview as RateReviewIcon,
  Feedback as FeedbackIcon,
  BugReport as BugReportIcon,
  Report as ReportIcon,
  ReportProblem as ReportProblemIcon,
  CheckBox as CheckBoxIcon,
  CheckBoxOutlineBlank as CheckBoxOutlineBlankIcon,
  IndeterminateCheckBox as IndeterminateCheckBoxIcon,
  RadioButtonChecked as RadioButtonCheckedIcon,
  RadioButtonUnchecked as RadioButtonUncheckedIcon,
  ToggleOn as ToggleOnIcon,
  ToggleOff as ToggleOffIcon,
  Explore as ExploreIcon,
  LocalAtm as LocalAtmIcon,
  Storefront as StorefrontIcon,
  AccountBalance as AccountBalanceIcon,
} from "@material-ui/icons";
import KanbanCard from "./KanbanCard";

// Mapa de ícones (mesmo do ColumnModal)
const iconMap = {
  // Padrão e Estrutura
  ViewColumn: ViewColumnIcon,
  Dashboard: DashboardIcon,
  Folder: FolderIcon,
  FolderOpen: FolderOpenIcon,
  Inbox: InboxIcon,
  
  // Pessoas e Contatos
  People: PeopleIcon,
  Person: PersonIcon,
  Group: GroupIcon,
  SupervisorAccount: SupervisorAccountIcon,
  AccountCircle: AccountCircleIcon,
  ContactMail: ContactMailIcon,
  VerifiedUser: VerifiedUserIcon,
  
  // Tarefas e Trabalho
  Assignment: AssignmentIcon,
  Work: WorkIcon,
  Build: BuildIcon,
  Description: DescriptionIcon,
  Notes: NotesIcon,
  NoteAdd: NoteAddIcon,
  
  // Status e Progresso
  CheckCircle: CheckCircleIcon,
  Done: DoneIcon,
  Cancel: CancelIcon,
  Error: ErrorIcon,
  Block: BlockIcon,
  Pause: PauseIcon,
  PlayArrow: PlayArrowIcon,
  TrendingUp: TrendingUpIcon,
  HourglassEmpty: HourglassEmptyIcon,
  Timer: TimerIcon,
  Update: UpdateIcon,
  Sync: SyncIcon,
  Refresh: RefreshIcon,
  
  // Prioridade e Marcadores
  Flag: FlagIcon,
  Star: StarIcon,
  Grade: GradeIcon,
  Bookmark: BookmarkIcon,
  Label: LabelIcon,
  LocalOffer: LocalOfferIcon,
  EmojiEvents: EmojiEventsIcon,
  Favorite: FavoriteIcon,
  FavoriteBorder: FavoriteBorderIcon,
  
  // Comunicação
  Phone: PhoneIcon,
  Email: EmailIcon,
  Chat: ChatIcon,
  Forum: ForumIcon,
  Comment: CommentIcon,
  QuestionAnswer: QuestionAnswerIcon,
  Send: SendIcon,
  Notifications: NotificationsIcon,
  Announcement: AnnouncementIcon,
  Explore: ExploreIcon,
  
  // Negócios e Financeiro
  Business: BusinessIcon,
  AttachMoney: AttachMoneyIcon,
  LocalAtm: LocalAtmIcon,
  Payment: PaymentIcon,
  Receipt: ReceiptIcon,
  ShoppingCart: ShoppingCartIcon,
  LocalShipping: LocalShippingIcon,
  Storefront: StorefrontIcon,
  Loyalty: LoyaltyIcon,
  CardGiftcard: CardGiftcardIcon,
  AccountBalance: AccountBalanceIcon,
  
  // Agendamento e Tempo
  Schedule: ScheduleIcon,
  CalendarToday: CalendarTodayIcon,
  Event: EventIcon,
  
  // Análise e Relatórios
  Assessment: AssessmentIcon,
  Timeline: TimelineIcon,
  Print: PrintIcon,
  Report: ReportIcon,
  
  // Feedback e Avaliação
  ThumbUp: ThumbUpIcon,
  ThumbDown: ThumbDownIcon,
  RateReview: RateReviewIcon,
  Feedback: FeedbackIcon,
  
  // Alertas e Avisos
  Warning: WarningIcon,
  Help: HelpIcon,
  Info: InfoIcon,
  NewReleases: NewReleasesIcon,
  BugReport: BugReportIcon,
  ReportProblem: ReportProblemIcon,
  
  // Segurança e Acesso
  Security: SecurityIcon,
  Lock: LockIcon,
  LockOpen: LockOpenIcon,
  VpnKey: VpnKeyIcon,
  Visibility: VisibilityIcon,
  VisibilityOff: VisibilityOffIcon,
  
  // Upload e Download
  CloudUpload: CloudUploadIcon,
  CloudDownload: CloudDownloadIcon,
  Archive: ArchiveIcon,
  
  // Localização e Acesso
  Room: RoomIcon,
  Language: LanguageIcon,
  Public: PublicIcon,
  
  // Seleção e Opções
  CheckBox: CheckBoxIcon,
  CheckBoxOutlineBlank: CheckBoxOutlineBlankIcon,
  IndeterminateCheckBox: IndeterminateCheckBoxIcon,
  RadioButtonChecked: RadioButtonCheckedIcon,
  RadioButtonUnchecked: RadioButtonUncheckedIcon,
  ToggleOn: ToggleOnIcon,
  ToggleOff: ToggleOffIcon,
  
  // Configurações
  Settings: SettingsIcon,
};

const useStyles = makeStyles((theme) => ({
  // A altura vem do stretch do columnsContainer (flex-item com flexGrow: 1
  // dentro do root de altura fixa da página); o maxHeight 100% é só teto. O
  // antigo calc(100vh - 200px) era um número solto que cortava a coluna em
  // viewport baixo.
  column: {
    minWidth: 300,
    width: 300,
    backgroundColor: theme.palette.background.default,
    borderRadius: theme.spacing(1),
    display: "flex",
    flexDirection: "column",
    maxHeight: "100%",
    [KANBAN_COMPACT_MQ]: {
      minWidth: 260,
      width: 260,
    },
  },
  // Altura FIXA (não minHeight) para os cabeçalhos de todas as colunas ficarem
  // alinhados — com minHeight, uma coluna com título de 2 linhas + badges
  // ficava mais alta que as vizinhas. 60px é o padrão acordado.
  columnHeader: {
    height: 60,
    minHeight: 60,
    boxSizing: "border-box",
    overflow: "hidden",
    padding: theme.spacing(1, 1.5),
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: "none",
    position: "relative",
    borderRadius: `${theme.spacing(1)}px ${theme.spacing(1)}px 0 0`,
    [KANBAN_COMPACT_MQ]: {
      padding: theme.spacing(1, 1),
    },
  },
  columnTitleContainer: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    flex: 1,
    minWidth: 0,
    padding: 0,
  },
  iconContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 36,
    height: 36,
    minWidth: 36,
    flexShrink: 0,
    borderRadius: "50%",
    [KANBAN_COMPACT_MQ]: {
      width: 28,
      height: 28,
      minWidth: 28,
    },
  },
  columnTitle: {
    flex: 1,
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(0.5),
    color: "#fff",
  },
  columnTitleText: {
    fontSize: 14,
    fontWeight: 600,
    color: "#fff",
    lineHeight: 1.2,
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    wordBreak: "break-word",
    [KANBAN_COMPACT_MQ]: {
      fontSize: 13,
    },
  },
  // Com badges embaixo do título, 2 linhas de título não cabem nos 60px do
  // cabeçalho; o nome completo continua no tooltip.
  columnTitleTextSingleLine: {
    WebkitLineClamp: 1,
  },
  columnBadges: {
    display: "flex",
    gap: theme.spacing(1),
    alignItems: "center",
    flexWrap: "nowrap",
    minWidth: 0,
  },
  columnActions: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
    flexShrink: 0,
    padding: 0,
  },
  cardsContainer: {
    padding: theme.spacing(1),
    overflowY: "auto",
    flexGrow: 1,
    minHeight: 100,
    ...theme.scrollbarStyles,
    [KANBAN_COMPACT_MQ]: {
      padding: theme.spacing(0.75),
    },
  },
  dragOver: {
    backgroundColor: theme.palette.action.hover,
  },
  addButton: {
    padding: theme.spacing(0),
  },
  limitBadge: {
    "& .MuiBadge-badge": {
      fontSize: 10,
      height: 16,
      minWidth: 16,
    },
  },
  showMoreButton: {
    marginTop: theme.spacing(0.5),
    textTransform: "none",
  },
}));

// Cards desenhados por vez em cada coluna. Os filtros e os totais do cabeçalho
// continuam sobre a coluna inteira; o corte é só no que vai para a tela.
const CARDS_PAGE_SIZE = 50;

// Quantos cards mostrar para que o card na posição `index` fique visível.
const visibleCountFor = (index) =>
  Math.max(CARDS_PAGE_SIZE, Math.ceil((index + 1) / CARDS_PAGE_SIZE) * CARDS_PAGE_SIZE);

export const VALID_SORT_OPTIONS = [
  "order",
  "date-desc",
  "date-asc",
  "alpha-asc",
  "ticket-id",
];

const KanbanColumn = ({
  column,
  boardId,
  sortOption = "order",
  filtersActive = false,
  onCardEdit,
  onCardDelete,
  onCardClone,
  onCardMove,
  onCardReorder,
  onAddCard,
  onEditColumn,
  onClearColumn,
  onDeleteColumn,
  draggingCardId,
  focusCardId, // card do deep link (?cardId=): a coluna se expande até ele
  onDragStart,
  onDragEnd,
  onColumnDragStart,
  onColumnDragEnd,
  onColumnDragOver,
  onColumnDrop,
  isDraggingColumn,
  canCreateCard = false,
  canEditColumn = false,
  canDeleteColumn = false,
  canEditCard = false,
  canDeleteCard = false,
  canCloneCard = false,
  onTasksUpdate, // Novo callback para atualizar quando tarefas mudarem
  inactivityTimerConfig,
}) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [isDragOver, setIsDragOver] = useState(false);
  const [dropTarget, setDropTarget] = useState(null); // { index, position: "top" | "bottom" }
  const [reportOpen, setReportOpen] = useState(false);

  // Reordenação manual por arraste só vale em "Ordem manual" (geral do board) e sem
  // nenhum filtro ativo, senão o índice exibido (sortedCards) não corresponde à
  // posição real no banco. Qualquer filtro (texto, data, tarefa, campo customizado
  // ou tag) torna a lista exibida um subconjunto não-contíguo de column.cards.
  const manualSortEnabled = sortOption === "order" && !filtersActive;

  // A filtragem de texto agora e feita no nivel do board (KanbanBoard/index.js):
  // aqui apenas ordenamos os cards ja filtrados que chegam em column.cards.

    const sortedCards = useMemo(() => {
      const cards = [...(column.cards || [])];

      switch (sortOption) {
        case "date-desc":
          return cards.sort(
            (a, b) => new Date(b.createdAt || 0).getTime() - new Date(a.createdAt || 0).getTime()
          );
        case "date-asc":
          return cards.sort(
            (a, b) => new Date(a.createdAt || 0).getTime() - new Date(b.createdAt || 0).getTime()
          );
        case "alpha-asc":
          return cards.sort((a, b) => (a.title || "").localeCompare(b.title || ""));
        case "ticket-id":
          return cards.sort((a, b) => {
            const aId = a.ticketId ?? a.ticket?.id ?? 0;
            const bId = b.ticketId ?? b.ticket?.id ?? 0;
            return aId - bId;
          });
        default:
          return cards;
      }
    }, [column.cards, sortOption]);

  const findFocusIndex = () =>
    focusCardId ? sortedCards.findIndex((card) => Number(card.id) === focusCardId) : -1;

  const [visibleCount, setVisibleCount] = useState(() => {
    const focusIndex = findFocusIndex();
    return focusIndex >= 0 ? visibleCountFor(focusIndex) : CARDS_PAGE_SIZE;
  });

  // Layout effect: roda antes dos timers do efeito de foco da página, então o
  // card do deep link já está no DOM quando ela procura por ele. Só aumenta.
  useLayoutEffect(() => {
    const focusIndex = findFocusIndex();
    if (focusIndex < 0) return;
    setVisibleCount((prev) => Math.max(prev, visibleCountFor(focusIndex)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [focusCardId, sortedCards]);

  const visibleCards = useMemo(
    () => sortedCards.slice(0, visibleCount),
    [sortedCards, visibleCount]
  );
  const hiddenCount = sortedCards.length - visibleCards.length;

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragOver(true);
  };

  const handleDragLeave = (e) => {
    setIsDragOver(false);
    setDropTarget(null);
  };

  // Limpa o indicador quando o arraste termina (drop fora de qualquer card).
  useEffect(() => {
    if (!draggingCardId) setDropTarget(null);
  }, [draggingCardId]);

  // Drop na área da coluna (fallback): drop em espaço vazio / abaixo do último card.
  // Os drops sobre um card são tratados por handleCardDrop (stopPropagation no card).
  const handleDrop = (e) => {
    // Com cards ocultos, "o fim da coluna" seria abaixo do corte e o card sumiria
    // da tela: no modo manual ele entra logo depois do último card visível.
    if (manualSortEnabled && hiddenCount > 0 && visibleCards.length > 0) {
      e.preventDefault();
      handleCardDrop(visibleCards.length - 1, "bottom", e);
      return;
    }

    e.preventDefault();
    setIsDragOver(false);
    setDropTarget(null);

    const cardId = parseInt(e.dataTransfer.getData("cardId"), 10);
    const fromColumnId = parseInt(e.dataTransfer.getData("columnId"), 10);
    if (!cardId || !fromColumnId) return;

    const sameColumn = fromColumnId === column.id;

    if (sameColumn) {
      // Reordenar na mesma coluna só faz sentido em modo manual; manda pro fim.
      if (!manualSortEnabled) return;
      const cards = sortedCards;
      const oldIndex = cards.findIndex((c) => c.id === cardId);
      if (oldIndex === -1 || oldIndex === cards.length - 1) return; // já é o último
      const reordered = [...cards];
      const [moved] = reordered.splice(oldIndex, 1);
      reordered.push(moved);
      onCardReorder?.(column.id, reordered.map((c) => c.id));
    } else {
      // Entre colunas (ou destino não-manual): vai pro fim (comportamento atual).
      onCardMove(cardId, fromColumnId, column.id, column.cards.length);
    }
  };

  // Pairar sobre um card específico: mostra o indicador acima/abaixo dele.
  // useStableCallback nos dois handlers de card: o dropTarget muda durante o
  // arraste e, com handlers novos a cada render, todos os cards re-renderizavam.
  const handleCardDragOver = useStableCallback((hoverIndex, position) => {
    setIsDragOver(false); // sobre um card não destacamos a coluna inteira
    setDropTarget((prev) =>
      prev && prev.index === hoverIndex && prev.position === position
        ? prev // evita re-render a cada evento de dragover
        : { index: hoverIndex, position }
    );
  });

  // Soltar sobre um card específico: calcula a posição-alvo exata.
  const handleCardDrop = useStableCallback((hoverIndex, position, e) => {
    setDropTarget(null);
    setIsDragOver(false);

    const cardId = parseInt(e.dataTransfer.getData("cardId"), 10);
    const fromColumnId = parseInt(e.dataTransfer.getData("columnId"), 10);
    if (!cardId || !fromColumnId) return;

    const cards = sortedCards; // === column.cards (contíguo) quando manualSortEnabled
    const insertIndex = position === "top" ? hoverIndex : hoverIndex + 1;
    const sameColumn = fromColumnId === column.id;

    if (sameColumn) {
      const oldIndex = cards.findIndex((c) => c.id === cardId);
      if (oldIndex === -1) return;

      // Off-by-one: ao remover o card antes do ponto de inserção, tudo
      // depois dele desloca uma posição à esquerda.
      let targetIndex = insertIndex;
      if (oldIndex < insertIndex) targetIndex -= 1;
      if (targetIndex === oldIndex) return; // sem mudança (inclui soltar em si mesmo)

      const reordered = [...cards];
      const [moved] = reordered.splice(oldIndex, 1);
      reordered.splice(targetIndex, 0, moved);
      onCardReorder?.(column.id, reordered.map((c) => c.id));
    } else {
      // Entre colunas: newOrder é o slot exato entre os cards do destino.
      const newOrder = Math.max(0, Math.min(insertIndex, cards.length));
      // Soltar abaixo do último visível: mostra mais um para o card não cair
      // na parte oculta da coluna.
      if (newOrder >= visibleCount) setVisibleCount(newOrder + 1);
      onCardMove(cardId, fromColumnId, column.id, newOrder);
    }
  });

  const cardCount = column.cards?.length || 0;
  const isAtLimit = column.limit && cardCount >= column.limit;

  // Calcular soma total dos valores dos cards da coluna
  const totalValue = useMemo(() => {
    if (!column.cards || column.cards.length === 0) return 0;
    
    return column.cards.reduce((sum, card) => {
      const valorReais = card.customFields?.valorReais;
      if (!valorReais) return sum;
      
      // Se o valor já está formatado (contém "R$"), fazer parsing
      let numValue = 0;
      if (typeof valorReais === 'string') {
        if (valorReais.includes('R$')) {
          // Remover "R$", pontos de milhar e substituir vírgula por ponto
          numValue = parseFloat(
            valorReais
              .replace('R$', '')
              .replace(/\./g, '')
              .replace(',', '.')
              .trim()
          );
        } else {
          numValue = parseFloat(valorReais.replace(/[^\d,.-]/g, '').replace(',', '.'));
        }
      } else {
        numValue = parseFloat(valorReais);
      }
      
      return sum + (isNaN(numValue) ? 0 : numValue);
    }, 0);
  }, [column.cards]);

  // Formatar valor total
  const formattedTotalValue = totalValue.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  // Obter o ícone apropriado
  const IconComponent = iconMap[column.icon] || ViewColumnIcon;

  const hasLimit = Boolean(column.limit && column.limit > 0);
  const showBadges = hasLimit || cardCount > 0 || totalValue > 0;

  return (
    <Paper
      id={`kanban-column-${column.id}`}
      data-column-id={column.id}
      className={`${classes.column} ${isDragOver ? classes.dragOver : ""}`}
      elevation={2}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
    >
      <div
        className={classes.columnHeader}
        style={{ 
          backgroundColor: column.color || "#3498db",
          cursor: "grab",
          opacity: isDraggingColumn ? 0.7 : 1,
        }}
        draggable
        onDragStart={(event) => onColumnDragStart?.(column.id, event)}
        onDragEnd={() => onColumnDragEnd?.()}
        onDragOver={(event) => onColumnDragOver?.(event)}
        onDrop={(event) => onColumnDrop?.(column.id, event)}
        title="Arraste para reordenar"
      >
        <div className={classes.columnTitleContainer}>
          <div
            className={classes.iconContainer}
          >
            <IconComponent
              fontSize="small"
              style={{ color: "#fff" }}
            />
          </div>

          <div className={classes.columnTitle}>
            <Tooltip title={column.name} enterDelay={400}>
              <Typography
                variant="h6"
                className={`${classes.columnTitleText} ${
                  showBadges ? classes.columnTitleTextSingleLine : ""
                }`}
              >
                {column.name}
              </Typography>
            </Tooltip>
            {showBadges && (
              <div className={classes.columnBadges}>
                {(hasLimit || cardCount > 0) && (
                  <div
                    className={classes.limitBadge}
                    style={{
                      backgroundColor: isAtLimit ? "rgba(244, 67, 54, 0.3)" : "rgba(255, 255, 255, 0.3)",
                      borderRadius: 12,
                      padding: "2px 8px",
                      flexShrink: 0
                    }}
                  >
                    <Typography variant="caption" style={{ color: "#fff", fontSize: 11, fontWeight: 500 }}>
                      {hasLimit ? `${cardCount}/${column.limit}` : cardCount}
                    </Typography>
                  </div>
                )}
                {totalValue > 0 && (
                  <Tooltip title={formattedTotalValue} enterDelay={400}>
                    <div
                      style={{
                        backgroundColor: "rgba(76, 175, 80, 0.3)",
                        borderRadius: 12,
                        padding: "2px 8px",
                        display: 'flex',
                        alignItems: 'center',
                        gap: 4,
                        minWidth: 0,
                        overflow: 'hidden'
                      }}
                    >
                      <AttachMoneyIcon style={{ fontSize: 12, color: "#fff", flexShrink: 0 }} />
                      <Typography variant="caption" noWrap style={{ color: "#fff", fontSize: 11, fontWeight: 500 }}>
                        {formattedTotalValue}
                      </Typography>
                    </div>
                  </Tooltip>
                )}
              </div>
            )}
          </div>
        </div>

        <div className={classes.columnActions}>
          {canCreateCard && (
            <IconButton
              className={classes.addButton}
              size="small"
              onClick={() => onAddCard(column)}
              disabled={isAtLimit}
              style={{ color: "#fff" }}
            >
              <AddIcon fontSize="small" />
            </IconButton>
          )}
          {(canEditColumn || canDeleteColumn) && (
            <IconButton
              className={classes.addButton}
              size="small"
              onClick={handleMenuOpen}
              style={{ color: "#fff" }}
            >
              <MoreVertIcon fontSize="small" />
            </IconButton>
          )}
        </div>

        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
        >
          {canEditColumn && (
            <MenuItem
              onClick={() => {
                onEditColumn(column);
                handleMenuClose();
              }}
            >
              Editar Coluna
            </MenuItem>
          )}
          {canDeleteColumn && (
            <MenuItem
              onClick={() => {
                onClearColumn(column);
                handleMenuClose();
              }}
            >
              Limpar Coluna
            </MenuItem>
          )}
          {canDeleteColumn && (
            <MenuItem
              onClick={() => {
                onDeleteColumn(column);
                handleMenuClose();
              }}
            >
              Excluir Coluna
            </MenuItem>
          )}
          <MenuItem
            onClick={() => {
              setReportOpen(true);
              handleMenuClose();
            }}
          >
            Relatório
          </MenuItem>
        </Menu>
      </div>

      <div className={classes.cardsContainer}>
        {visibleCards.map((card, index) => (
          <KanbanCard
            key={card.id}
            card={card}
            index={index}
            onEdit={onCardEdit}
            onDelete={onCardDelete}
            onClone={onCardClone}
            onDragStart={onDragStart}
            onDragEnd={onDragEnd}
            isDragging={draggingCardId === card.id}
            canEdit={canEditCard}
            canDelete={canDeleteCard}
            canClone={canCloneCard}
            onTasksUpdate={onTasksUpdate}
            inactivityTimerConfig={inactivityTimerConfig}
            manualSortEnabled={manualSortEnabled}
            onCardDragOver={handleCardDragOver}
            onCardDrop={handleCardDrop}
            dropIndicator={
              dropTarget?.index === index ? dropTarget.position : null
            }
          />
        ))}

        {hiddenCount > 0 && (
          <Button
            size="small"
            color="primary"
            fullWidth
            className={classes.showMoreButton}
            onClick={() => setVisibleCount((prev) => prev + CARDS_PAGE_SIZE)}
          >
            {`Mostrar mais (${hiddenCount} ${hiddenCount === 1 ? "restante" : "restantes"})`}
          </Button>
        )}

        {cardCount === 0 && (
          <Typography
            variant="body2"
            color="textSecondary"
            align="center"
            style={{ marginTop: 20 }}
          >
            Nenhum card nesta coluna
          </Typography>
        )}
      </div>

      {/* Só monta aberto: fechado, ele percorria todos os cards da coluna a cada
          atualização do board. */}
      {reportOpen && (
        <ColumnReportModal
          open={reportOpen}
          onClose={() => setReportOpen(false)}
          column={column}
          boardId={boardId || column?.boardId}
        />
      )}
    </Paper>
  );
};

// Memo: a página re-renderiza a cada tecla no filtro, arraste ou modal aberto;
// a coluna só precisa redesenhar quando os próprios props mudam.
export default React.memo(KanbanColumn);
